import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box } from "@mui/material";
import { Container, Row, Col } from "react-bootstrap";
import PageCover from "../Components/Shared/PageCover";
import faq from "../Components/Assets/Images/faq.jpg";
import { generalQuery,bookingQuery,refundCancelledQuery,luggagePackingQuery } from "../Components/Shared/FAQsData";
import { motion } from "framer-motion";

const FAQs = () => {


  return (
    <>
      <motion.div
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ x: 100, opacity: 0 }}
          transition={{ duration: 1, ease: "easeInOut" }}
          viewport={{ once: false, amount: 0.5  }}
      >
          <PageCover
            image={faq}
            title="Frequently Asked Questions"
            subtitle="Welcome to Our World, Where Innovation Meets Purpose, and Possibilities Unfold"
          />

      </motion.div>
      <Box className="faq-section" style={{  backgroundColor: '#d4dbdfd4',padding: "4rem 0" }}>
        <Container>
          <Row>
            <Col lg={6} className="faqAccordian">
            <motion.div
              initial={{ x: -100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 100, opacity: 0 }}
              transition={{ duration: 1.3, ease: "easeInOut" }}
              viewport={{ once: false, amount: 0.5  }}
            >
              <Typography variant="body1" component="p" style={{fontSize:'28px', fontWeight:'600', marginBottom:'18px'}}>General Quries</Typography>
              {generalQuery.map((faq) => (
                <Accordion key={faq.id} slotProps={{ transition: { unmountOnExit: true } }}>
                  <AccordionSummary  sx={{boxShadow: 'none'}} expandIcon={<ExpandMoreIcon />}>
                    <Typography>{faq.question}</Typography>
                  </AccordionSummary>
                  <AccordionDetails className="faqDetails" sx={{boxShadow: 'none'}}>
                    <Typography>{faq.answer}</Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </motion.div>
            </Col>

            <Col lg={6} className="faqAccordian">
            <motion.div
              initial={{ x: 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 100, opacity: 0 }}
              transition={{ duration: 1.5, ease: "easeInOut" }}
              viewport={{ once: false, amount: 0.5  }}
            >
              <Typography variant="body1" component="p" style={{fontSize:'28px', fontWeight:'600', marginBottom:'18px'}}>Booking Related Quries</Typography>
              {bookingQuery.map((faq) => (
                <Accordion key={faq.id} slotProps={{ transition: { unmountOnExit: true } }}>
                  <AccordionSummary  sx={{boxShadow: 'none'}} expandIcon={<ExpandMoreIcon />}>
                    <Typography>{faq.question}</Typography>
                  </AccordionSummary>
                  <AccordionDetails className="faqDetails" sx={{boxShadow: 'none'}}>
                    <Typography>{faq.answer}</Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </motion.div>
            </Col>
          </Row>
        </Container>
      </Box>
        <Box style={{ backgroundColor: "#e8eef1", padding:'4rem 0' }}>
          <Container>
            <Row>
            <Col lg={6} className="faqAccordian">
            <motion.div
              initial={{ x: -100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              // exit={{ x: 100, opacity: 0 }}
              transition={{ duration: 0.9, ease: "easeInOut" }}
              viewport={{ once: false, amount: 0.6  }}
            >
              <Typography variant="body1" component="p" style={{fontSize:'28px', fontWeight:'600', marginBottom:'18px'}}>Refund & Cancellation</Typography>
              {refundCancelledQuery.map((faq) => (
                <Accordion key={faq.id} slotProps={{ transition: { unmountOnExit: true } }}>
                  <AccordionSummary  sx={{boxShadow: 'none'}} expandIcon={<ExpandMoreIcon />}>
                    <Typography>{faq.question}</Typography>
                  </AccordionSummary>
                  <AccordionDetails className="faqDetails" sx={{boxShadow: 'none'}}>
                    <Typography>{faq.answer}</Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </motion.div>
            </Col>

            <Col lg={6} className="faqAccordian">
            <motion.div
              initial={{ x: 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              // exit={{ x: 100, opacity: 0 }}
              transition={{ duration: 0.9, ease: "easeInOut" }}
              viewport={{ once: false, amount: 0.6  }}
            >
              <Typography variant="body1" component="p" style={{fontSize:'28px', fontWeight:'600', marginBottom:'18px'}}>Luggage & Packing</Typography>
              {luggagePackingQuery.map((faq) => (
                <Accordion key={faq.id} slotProps={{ transition: { unmountOnExit: true } }}>
                  <AccordionSummary  sx={{boxShadow: 'none'}} expandIcon={<ExpandMoreIcon />}>
                    <Typography>{faq.question}</Typography>
                  </AccordionSummary>
                  <AccordionDetails className="faqDetails" sx={{boxShadow: 'none'}}>
                    <Typography>{faq.answer}</Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </motion.div>
            </Col>
            </Row>
          </Container>
        </Box>
    </>
  );
};

export default FAQs;
